import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-atributos',
  templateUrl: './atributos.component.html',
  styleUrls: ['./atributos.component.scss']
})
export class AtributosComponent {
  displayedColumns: string[] = ['name', 'weight', 'symbol', 'position'];
  columnsToDisplay: string[] = this.displayedColumns.slice();
  dataTemp: any[] = [];
  data: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public attr: { data: any },
    public dialogRef: MatDialogRef<AtributosComponent>
  ) {
    this.data = attr;
    this.data.sort(this.compareByOrder)
  }

  compareByOrder(a:any, b:any) {
    return a.ordem - b.ordem;
  }

  return(){
     this.dialogRef.close();
  }
}
